<template>
  <div class="about">
    <div class="head">
      <p>{{ about }}</p>
    </div>
    <p class="text">
      {{ title }}
    </p>
    <div class="content">
      <div class="section">
        <p>{{ content1 }}{{ content4 }}</p>
        <p></p>
      </div>
      <div class="section">
        <p>{{ content2 }}</p>
        <p>{{ content3 }}</p>
      </div>
    </div>
    <div class="btnbox">
      <p>投递商业计划书</p>
      <div class="btn">
        <p>
          <a href="mailto:bp@atlascap.com.cn">助力创业理想</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      navlist: [
        // { title: "公司文化", desc: "仁爱、敬畏、学习", type: "culture" }
      ]
    };
  },
  methods: {
    changeModel(type) {
      this.$emit("changeModel", true, type);
    }
  },
  computed: {
    ...mapGetters({ language: "getType" }),
    about() {
      return this.language == "中文" ? "关于·	知春资本" : "About Atlas";
    },
    desc() {
      return this.language == "中文"
        ? "我们在算力解放创造力的路上不断前行；以技术驱动的线上化为主线，重点布局社交娱乐、医疗健康、消费等领域。"
        : "Enabling innovation through computing power and pursuing tech-driven interconnectedness, we focus on fields in social media, entertainment, medical and health industry, and the consumer market.";
    },
    title() {
      return this.language == "中文"
        ? "仁爱、敬畏、学习"
        : "and the consumer market.";
    },
    content1() {
      return this.language == "中文"
        ? "知春资本成立于2017年5月，是一家聚焦于新经济领域的创业投资基金，专注投资下一个十年科技创新、社会结构变化所带来的商业机会。"
        : "and the consumer market.";
    },
    content4() {
      return this.language == "中文"
        ? "我们聚焦中国企业，致力于寻找到新科技、新消费、新娱乐领域里的卓越公司和优秀创始人，并伴随他们成长。"
        : "and the consumer market.";
    },
    content2() {
      return this.language == "中文"
        ? "打造对产业未来趋势持续迭代的认知体系，寻找并助力能为世界创造价值的卓越公司，是我们努力的两大核心目标。 "
        : "and the consumer market.";
    },
    content3() {
      return this.language == "中文"
        ? "获得清科、投资界联合发布的“2021年中国早期投资机构30强”；36氪发布的“2021最受创业者欢迎早期投资机构”。 "
        : "and the consumer market.";
    }
  }
};
</script>
<style scoped lang="less">
.about {
  width: 1200px;
  padding-bottom: 67px;
  margin: 0 auto;
  .text {
    font-size: 18px;
    color: #8c8c8c;
    text-align: center;
    margin-top: 10px;
  }
  .head {
    width: 393px;
    border-bottom: 1px solid rgba(51, 51, 51, 0.25);
    margin: 0 auto;
    p {
      font-size: 36px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      line-height: 65px;
    }
  }
  .content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 48px;
    .section {
      width: 547px;
      p {
        font-size: 18px;
        font-family: "微软雅黑";
        font-weight: 500;
        color: #424242;
        white-space: pre-line;
        line-height: 32px;
        // text-align: justify;
      }
    }
  }
  .btnbox {
    width: 340px;
    margin: 66px auto 0;
    p {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #6e6e6e;
      text-align: center;
    }
    a {
      text-decoration: none;
      color: #fff;
    }
    .btn {
      width: 340px;
      height: 68px;
      background: #ff8f3c;
      border-radius: 34px;
      margin-top: 19px;
      cursor: pointer;
      &:hover {
        background: #ff6c00;
      }
      p {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
        line-height: 68px;
      }
    }
  }
  .aboutbox {
    width: 100%;
    display: flex;
    justify-content: space-around;
    margin-top: 104px;
    .item {
      width: 314px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 38px;
      border-bottom: 1px solid rgba(185, 185, 185, 0.46);
      .title {
        span {
          display: inline-block;
          width: 35px;
          height: 35px;
          background: rgba(109, 221, 176, 1);
          border-radius: 50%;
          margin-right: 11px;
          p {
            font-size: 26px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            text-align: center;
            line-height: 38px;
          }
        }
        font-size: 22px;
        color: rgba(51, 51, 51, 1);
        margin-top: 32px;
      }
      .text {
        font-size: 18px;
        color: rgba(51, 51, 51, 1);
      }
      .btn {
        cursor: pointer;
        margin-top: 42px;
        width: 166px;
        height: 54px;
        background: url("../assets/button.png");
        background-size: 100% 100%;
        &:hover {
          transform: scale(1.1);
          transition: 0.2s all;
        }
        p {
          font-size: 20px;
          color: rgba(255, 255, 255, 1);
          text-align: center;
          line-height: 54px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue